var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Xuất file tổng hợp điểm danh",
            visible: _vm.dialogVisible,
            width: "500px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "10vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataInput",
              attrs: {
                "label-width": "100px",
                model: _vm.dataInput,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Chọn ngày" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "daterange",
                      "unlink-panels": "",
                      "start-placeholder": "Ngày bắt đầu",
                      "end-placeholder": "Ngày kết thúc",
                      "value-format": "yyyy-MM-dd",
                      format: "dd-MM-yyyy",
                    },
                    model: {
                      value: _vm.dateStartEnd,
                      callback: function ($$v) {
                        _vm.dateStartEnd = $$v
                      },
                      expression: "dateStartEnd",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: { label: "Chọn kiểu" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.dataInput.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataInput, "type", $$v)
                        },
                        expression: "dataInput.type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("Toàn bộ nhóm"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("Theo nhóm"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.dataInput.type == false
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { label: "Chọn nhóm" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          attrs: { clearable: "", placeholder: "Chọn nhóm" },
                          model: {
                            value: _vm.dataInput.idGroup,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "idGroup", $$v)
                            },
                            expression: "dataInput.idGroup",
                          },
                        },
                        _vm._l(_vm.kidGroupList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item.id, label: item.nameGroup },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "Trạng thái", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "button-left-status",
                      staticStyle: { width: "300px" },
                      attrs: { clearable: "", placeholder: "Trạng thái" },
                      model: {
                        value: _vm.dataInput.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataInput, "status", $$v)
                        },
                        expression: "dataInput.status",
                      },
                    },
                    _vm._l(_vm.kidStatusList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { value: item.key, label: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialog()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("button.close")))]),
                ]
              ),
              this.dateStartEnd.length == 0 || this.dataInput.status == null
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        size: "medium",
                        disabled: "",
                        loading: _vm.loadingButton,
                        mini: "",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Xuất file")]),
                    ]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        size: "medium",
                        loading: _vm.loadingButton,
                        mini: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Xuất file")]),
                    ]
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c("PeopleTypeCreate", {
        attrs: { dialogVisible: _vm.showCreateDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseCreateMethod()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }